"use client";

import { useState } from "react";
import Plus from "../svg/plus";
import Minus from "../svg/minus";

interface ToggleListProps {
    title: string;
    items: Array<{
        id: number; 
        Item: string;
    }>;
    values: { [key: number]: number };
    onValueChange: (id: number, value: number) => void;
}

export default function ToggleList({ title, items, values, onValueChange }: ToggleListProps) {
    const [isOpen, setIsOpen] = useState(false);

    const toggleOpen = () => setIsOpen(!isOpen);

    return (
        <button className="border border-violet-50 py-[24px] px-[32px] rounded-2xl shadow-[0_4px_16px_0_#0000001a] w-full max-[576px]:p-[20px] max-[576px]:rounded-[16px]">
            <div
                className="flex justify-between items-center cursor-pointer"
                onClick={toggleOpen}
            >
                <span className="text-[28px] text-black leading-[129%] font-bold max-[576px]:text-[20px]">{title}</span>
                <span className="text-xl">{isOpen ? <Minus /> : <Plus />}</span>
            </div>
            <div
                className={`cursor-auto transition-all duration-300 overflow-hidden ${isOpen ? 'opacity-100' : 'max-h-0 opacity-0'}`}
            >
                <div className="mt-4 space-y-4">
                    {items.map((item) => (
                        <div
                            key={item.id}
                            className="flex justify-between items-center border-t-2 border-gray-200 border-dotted pt-4"
                        >
                            <span className="text-[20px] text-violet-300 font-normal leading-[120%]">{item.Item}</span>
                            <div className="flex items-center gap-2">
                                <input
                                    type="number"
                                    min={0}
                                    placeholder="0"
                                    value={values[item.id] || ""}
                                    onChange={(e) => {
                                        const value = parseInt(e.target.value, 10) || 0;
                                        onValueChange(item.id, value);
                                    }}
                                    onWheel={(e) => e.currentTarget.blur()}
                                    className="text-[20px] text-violed-200 leading-[100%] w-[132px] h-[44px] text-end border-2 rounded-lg no-spinner p-[10.5px] focus-visible:border focus-visible:outline-0"
                                />
                                <span>St</span>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </button>
    );
}